const AustriaFlag = () => {
	return (
		<svg aria-hidden="true" focusable="false" role="img" width="20" height="20" viewBox="0 0 50 50">
			<path
				fill="#F0F0F0"
				d="M48.445 33.695A24.943 24.943 0 0 0 50 24.999c0-3.058-.55-5.987-1.555-8.695L25 14.13 1.555 16.304A24.947 24.947 0 0 0 0 24.999c0 3.058.55 5.988 1.555 8.696L25 35.869l23.445-2.174Z"
			></path>
			<path
				fill="#D80027"
				d="M25 50c10.749 0 19.913-6.784 23.445-16.304H1.555C5.087 43.216 14.25 50 25 50Zm0-50C14.25 0 5.087 6.784 1.555 16.304h46.89C44.913 6.784 35.749 0 25 0Z"
			></path>
		</svg>
	);
};

export default AustriaFlag;
